import React from 'react';
import { embedFrameStyle } from '../../utils/imageEmbed';

/**
 * The iframe half of an embedded image block (Pinterest, Flickr, Instagram …).
 *
 * Providers serve a fixed-size card, so the frame keeps the provider's own
 * width and aspect ratio and only shrinks when the column is narrower than
 * that — scaling up would just leave the card floating in empty space.
 */
const ImageEmbedFrame = ({ block, className = '' }) => {
    const { width, aspectRatio } = embedFrameStyle(block);
    const title = block.alt || block.imageTitle || 'Embedded image';

    return (
        <div
            className={`relative mx-auto overflow-hidden rounded-xl shadow-lg bg-gray-50 ${className}`}
            style={{ width: `min(100%, ${width}px)`, aspectRatio }}
        >
            <iframe
                src={block.imageEmbedSrc}
                title={title}
                className="absolute inset-0 w-full h-full border-0"
                scrolling="no"
                loading="lazy"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
            />
        </div>
    );
};

export default ImageEmbedFrame;
